import { Font } from '@react-pdf/renderer';

let registered = false;

export const registerPDFFonts = () => {
  if (registered) return;
  registered = true;

  Font.register({
    family: 'Roboto',
    fonts: [
      { src: '/fonts/Roboto-Regular.ttf', fontWeight: 'normal', fontStyle: 'normal' },
      { src: '/fonts/Roboto-Bold.ttf', fontWeight: 'bold', fontStyle: 'normal' },
      { src: '/fonts/Roboto-Italic.ttf', fontWeight: 'normal', fontStyle: 'italic' },
    ],
  });

  Font.registerHyphenationCallback((word) => [word]);
};
